import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Language, LanguageService } from './language.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageCheckService {

  public selectedLanguage: Language = 'de';

  constructor(private languageService: LanguageService, @Inject(DOCUMENT) private document: Document) {
  }

  /**
   * Called by app.module.ts before app is loaded (via APP_INITIALIZER).
   * Prevents loading application with wrong language.
   */
  initializeApp(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.selectedLanguage = this.languageService.getLanguage();
      const appLanguage = this.document.documentElement.lang;
      if (appLanguage !== this.selectedLanguage) {
        this.switchLanguage(this.selectedLanguage);
        reject(new Error('Wrong language in url'));
      }
      resolve(true);
    });
  }

  /**
   * To change the language we need to navigate to a different url with a translated version of the app,
   * because language needs to be defined at build-time, and we cannot change it dynamically.
   */
  switchLanguage(selectedLanguage: Language) {
    this.languageService.saveLastLanguage(selectedLanguage);
    this.navigateToOtherLanguage(selectedLanguage);
  }

  getCurrentLocation(): string {
    return location.href;
  }

  setCurrentLocation(newLocation: string) {
    location.href = newLocation;
  }

  private navigateToOtherLanguage(selectedLanguage: Language) {
    const urlPaths = this.getCurrentLocation().split('/');
    const index = urlPaths.findIndex(val => val === 'visum-erfassung');
    urlPaths[index + 1] = selectedLanguage; // change language part of URL, comes directly after startseite, e.g. startseite/en
    this.setCurrentLocation(urlPaths.join('/'));
  }
}
